import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";

type ItemProp = {
  idx: number;
  data: any;
  selected: number;
  totalCnt: number;
  goalExplain: string;
  hideExplain: boolean[];
  setHideExplain: React.Dispatch<React.SetStateAction<any[]>>;
  onClick: () => void;
  // onClickHandler: () => void;
};

const GoalGroup = ({
  idx,
  data,
  selected,
  totalCnt,
  goalExplain,
  hideExplain,
  setHideExplain,
  onClick,
}: ItemProp) => {
  const { t } = useTranslation();
  const [hide, setHide] = useState(true);
  const handleHideExplain = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    var val = Array(hideExplain.length).fill(true);
    val[idx] = !hideExplain[idx];
    setHideExplain(val);
    // setHide(!val);
    // setHideExplain(!val);
  };
  // console.log(hideExplain);
  return (
    <div className="goal-group" onClick={onClick}>
      <button className="exclamation-mark" onClick={(e) => handleHideExplain(e)}></button>
      {hideExplain[idx] === false && (
        <div className="explain goal-explain" onClick={(e) => handleHideExplain(e)}>
          <span>{goalExplain}</span>
        </div>
      )}
      <div className="goal-group-title">
        {t("policy-group")} [{idx + 1}]
        <br />
        {data}
      </div>
      <div className="goal-group-info" onClick={onClick}>
        ({t("selectedPolicies", { total: totalCnt, selected: selected })})
      </div>
    </div>
  );
};

export default GoalGroup;
